/* Release 6.4, About and Impact (10_Spec_Release_6_4_About_and_Impact.md v1.0).
   Loads only from sections/au-r64-about.liquid and au-r64-impact.liquid with
   their switch on.

   1. Tap to play. Nothing goes to YouTube before the tap: no script, iframe
      or thumbnail. The tap puts a youtube-nocookie player in the button's
      frame (the poster on a card, the slot under the hero buttons), with a
      title naming the person, and moves focus to it. The owner confirmed on
      10 October 2026 that the tap counts as consent (spec 2.3).
   2. Quick add on the three About products stays on the page, through
      au-purchase (window.AUPurchase.add without the jump to /cart). After a
      confirmed add the purchase block is replaced by a fresh copy labelled
      "Mais um" / "Mais uma" and "[n] na sacola" shows (as on the 6.3 cards).
   3. Events: about_video_play (person), about_quick_add (handle),
      about_whatsapp_click, impact_record_click (target). */
(() => {
  if (window.AUR64) return;
  window.AUR64 = true;
  const roots = [...document.querySelectorAll('[data-au-r64]')];
  if (!roots.length) return;
  const track = (event, payload = {}) => { try { window.AVAnalytics?.custom?.(event, payload); } catch (_) { /* analytics are optional */ } };
  const inside = (node) => roots.some((root) => root.contains(node));

  /* 1. Tap to play */
  const play = (button) => {
    const id = button.dataset.video || '';
    const frame = document.getElementById(button.dataset.player || '');
    if (!/^[A-Za-z0-9_-]{6,20}$/.test(id) || !frame) return;
    const iframe = document.createElement('iframe');
    // Portuguese captions, as the live About player asks (au-qa S2-1, WCAG 1.2.2)
    iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1&modestbranding=1&cc_load_policy=1&cc_lang_pref=pt`;
    iframe.title = button.dataset.title || button.textContent.trim();
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.replaceChildren(iframe);
    frame.hidden = false;
    frame.classList.add('is-playing');
    if (button.isConnected) button.remove();
    iframe.focus({ preventScroll: true });
    track('about_video_play', { person: button.dataset.person || '' });
  };

  /* 2. Quick add on the About products */
  const host = (node) => node?.closest?.('[data-au-r64-item]');
  const nameButton = (item, block, label) => {
    const button = block?.querySelector('[data-au-purchase-submit]');
    if (!button) return;
    const product = item.querySelector('.au-r64-trio__name')?.textContent.replace(/\s+/g, ' ').trim() || '';
    const shown = (label || button.querySelector('[data-au-purchase-label]')?.textContent || '').trim();
    const template = `${shown}${product ? `, ${product}` : ''}, [[price]]`;
    button.dataset.auNameTemplate = template;
    const price = button.querySelector('[data-au-purchase-total]')?.textContent.trim();
    if (button.hasAttribute('aria-label') && price) button.setAttribute('aria-label', template.replace('[[price]]', price));
  };
  const pristine = new WeakMap();
  document.querySelectorAll('[data-au-r64-item]').forEach((item) => {
    const block = item.querySelector('[data-au-purchase]');
    if (!block) return;
    nameButton(item, block);
    pristine.set(item, block.cloneNode(true));
  });
  const showInBag = (cart) => {
    const perProduct = new Map();
    for (const line of cart?.items || []) perProduct.set(String(line.product_id), (perProduct.get(String(line.product_id)) || 0) + Number(line.quantity || 0));
    document.querySelectorAll('[data-au-r64-item]').forEach((item) => {
      const inBag = item.querySelector('[data-au-r64-inbag]');
      if (!inBag) return;
      const qty = perProduct.get(String(item.dataset.productId)) || 0;
      // the line stays in the page (role status), so a screen reader hears the count change (au-qa S3-2)
      const text = qty > 0 ? (item.dataset.inBag || '').replace('[[n]]', String(qty)) : '';
      if (inBag.textContent !== text) inBag.textContent = text;
    });
  };
  const refreshCart = async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) return;
      showInBag(await response.json());
    } catch (_) { /* the line stays as rendered */ }
  };
  const renew = (item, hadFocus) => {
    const old = item.querySelector('[data-au-purchase]');
    const copy = pristine.get(item);
    if (!old || !copy) return;
    const fresh = copy.cloneNode(true);
    const more = item.dataset.more || '';
    const config = fresh.querySelector('[data-au-purchase-config]');
    if (config && more) {
      try { const data = JSON.parse(config.textContent); data.labels = { ...(data.labels || {}), add: more }; config.textContent = JSON.stringify(data); } catch (_) { /* keep the original label */ }
    }
    const label = fresh.querySelector('[data-au-purchase-label]');
    if (label && more) label.textContent = more;
    nameButton(item, fresh, more);
    old.replaceWith(fresh);
    try { window.AUPurchase?.init?.(item); } catch (_) { /* the native form still works */ }
    if (hadFocus) fresh.querySelector('[data-au-purchase-submit], button[type="submit"]')?.focus({ preventScroll: true });
  };
  window.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-au-purchase-form')) return;
    const item = host(form) || host(document.querySelector(`[form="${CSS.escape(form.id)}"]`));
    if (!item || !inside(item) || !window.AUPurchase?.add) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const hadFocus = item.contains(document.activeElement);
    window.AUPurchase.register(form);
    let result = null;
    try { result = await window.AUPurchase.add(form, { navigate: false }); } catch (_) { result = null; }
    if (!result || !['confirmed', 'partial'].includes(result.status)) return;
    track('about_quick_add', { handle: item.dataset.handle });
    if (result.cart && Array.isArray(result.cart.items)) showInBag(result.cart);
    await refreshCart();
    renew(item, hadFocus);
  }, true);

  /* 3. Clicks */
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element) || !inside(target)) return;
    const button = target.closest('[data-au-r64-play]');
    if (button) { event.preventDefault(); play(button); return; }
    if (target.closest('[data-au-r64-whatsapp]')) track('about_whatsapp_click');
    const record = target.closest('[data-au-r64-record]');
    if (record) track('impact_record_click', { target: record.dataset.auR64Record });
  });

  window.addEventListener('pageshow', (event) => { if (event.persisted) void refreshCart(); });
})();
